import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, FormControlLabel, Grid, Switch, Typography } from "@mui/material"
import PaperBox from "components/PaperBox"
import { IIssuereportNotification } from "./IssuereportNotification.interfaces"
import { faMailbox } from "@fortawesome/pro-solid-svg-icons"
import { StyledPrimaryAvatar } from "shared/styled/Global"
import { useTranslation } from "react-i18next"

const IssueReportNotification = ({ setFieldValue, values }: IIssuereportNotification) => {
  const { t } = useTranslation()
  return (
    <PaperBox>
      <Grid container direction="row" justifyContent="space-between" alignItems="center">
        <Grid item xs={2}>
          <Box>
            <StyledPrimaryAvatar
              arial-label={t("issuereports.notification_send_to_admin", "Notifications when a bug report is submitted to admin")}>
              <FontAwesomeIcon icon={faMailbox} size="lg" />
            </StyledPrimaryAvatar>
          </Box>
        </Grid>

        <Grid item xs={8}>
          <Typography variant="h5">{t("issuereports.notification_send_to_admin", "Notifications when a bug report is submitted to admin")}</Typography>
        </Grid>
        <Grid item xs={2}>
          <FormControlLabel
            label=""
            sx={{ margin: 0 }}
            id="issueReportNotification"
            control={
              <Switch
                checked={values.issueReportNotificationActive}
                onChange={(e: any) => {
                  setFieldValue("issueReportNotificationActive", e.target.checked)
                }}
              />
            }
          />
        </Grid>
      </Grid>
    </PaperBox>
  )
}

export default IssueReportNotification
